import Vue from 'vue'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
import './styles/stylus/index.styl'
import Icon from 'vue-svg-icon/Icon.vue'
require('./mock/' + process.env.MOCK_FILE_NAME)
import router from './router'
import store from './store'
import './router-guards'
import App from './App'
import '@/directive/checkBtnRole';
import * as filters from '@/filter';
import vueLogger from 'vue-logger';
import { dateFormat } from '@/utils/util'

let levels = [];
let isLog = false;
if (process.env.NODE_ENV !== 'production') {
  isLog = true;
  levels = ['warn', 'error'];
} else {
  isLog = false;
  levels = ['log', 'warn', 'debug', 'error', 'dir'];
}
Vue.use(vueLogger, {
  prefix: () => dateFormat('yyyy-MM-dd hh:mm:ss.S'),
  dev: isLog,
  shortname: true,
  levels: levels,
  forceLevels: ['error']
});

Vue.use(ElementUI)
Vue.component('icon', Icon)
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js